"use client";

import { Box, Typography } from "@mui/material";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import StarIcon from "@mui/icons-material/Star";
import {
  FEATURED_COLOR,
  BRAND_COLOR,
  PRIMARY_COLOR,
} from "@/app/layout/LayoutConstants";
import Ribbon from "../common/Ribbon";

export interface AdPriceRibbonProps {
  isInactive: boolean;
  isSold: boolean;
  isUrgent: boolean;
  isFeatured: boolean;
  pricePrefix?: string;
  price: string;
  priceSuffix?: string;
}

export default function AdPriceRibbon({
  ad,
  alwaysSmall,
}: {
  ad: AdPriceRibbonProps;
  alwaysSmall?: boolean;
}) {
  let backgroundColor = PRIMARY_COLOR;
  if (!ad.isSold) {
    if (ad.isUrgent) {
      backgroundColor = BRAND_COLOR;
    } else if (ad.isFeatured) {
      backgroundColor = FEATURED_COLOR;
    }
  }

  return (
    <Ribbon
      backgroundColor={backgroundColor}
      alwaysSmall={alwaysSmall}
      orientation="right"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
        }}
      >
        {ad.isUrgent ? (
          <>
            <WhatshotIcon sx={{ fontSize: "inherit", alignSelf: "center" }} />
            &nbsp;
          </>
        ) : (
          ad.isFeatured && (
            <>
              <StarIcon
                sx={{
                  fontSize: "inherit",
                  alignSelf: "center",
                }}
              />
              &nbsp;
            </>
          )
        )}
        {ad.pricePrefix && (
          <Typography sx={{ fontSize: ad.isSold ? "inherit" : "80%" }}>
            {ad.pricePrefix}&nbsp;
          </Typography>
        )}
        <Typography
          sx={{
            textDecoration: ad.isSold ? "line-through" : "none",
            fontSize: ad.isSold ? "80%" : "inherit",
          }}
        >
          {ad.price}
        </Typography>
        {ad.priceSuffix && (
          <Typography
            sx={{
              fontSize: "80%",
            }}
          >
            &nbsp;{ad.priceSuffix}
          </Typography>
        )}
      </Box>
    </Ribbon>
  );
}
